import './index.scss'

jQuery(($) => {
    let $carousels = $('.carousel--related-posts')
  
    function initCarousel($carousel) {
        $carousel.owlCarousel({
            dots: false,
            nav: false,
            autoWidth: true
        })
    }
  
    function destroyCarousel($carousel) {
        if ($carousel.hasClass('owl-loaded')) {
            $carousel
                .trigger('destroy.owl.carousel')
                .removeClass('owl-carousel owl-loaded')
                .find('.owl-stage-outer').children().unwrap()
        }
    }
  
    function handleCarousel() {
        let windowWidth = $(window).width()
  
        $carousels.each((index, element) => {
            let $carousel = $(element)
            if (windowWidth <= 1200) {
                if (!$carousel.hasClass('owl-loaded')) {
                    initCarousel($carousel)
                }
            } else {
                destroyCarousel($carousel)
            }
        })
    }
  
    handleCarousel()
  
    $(window).on('resize', function() {
      handleCarousel();
    })
})
  